module.exports = __webpack_public_path__ + "sharp-sans-bold-subset-a6f0cc5323f9b6e6750e6096774b181c.bundle.woff";